/**
 * Auth Service — calls dev-login/logout/config/me backend endpoints.
 */
import apiClient from './apiClient';

const authService = {
  /**
   * GET /api/auth/config — returns { devLoginEnabled: boolean }
   * @param {AbortSignal} signal - Optional AbortSignal for cancellation
   */
  async getConfig(signal = null) {
    const { data } = await apiClient.get('/api/auth/config', { signal });
    return data;
  },

  /**
   * POST /api/auth/dev-login — authenticate by identifier (email or username/customer employee id)
   * @param {string} identifier
   * @param {AbortSignal} signal - Optional AbortSignal for cancellation
   */
  async devLogin(identifier, signal = null) {
    const { data } = await apiClient.post('/api/auth/dev-login', { identifier }, { signal });
    return data;
  },

  /**
   * POST /api/auth/logout — clear session
   * @param {AbortSignal} signal - Optional AbortSignal for cancellation
   */
  async logout(signal = null) {
    const { data } = await apiClient.post('/api/auth/logout', {}, { signal });
    return data;
  },

  /**
   * GET /api/me — returns current user with roles and permissions
   * @param {AbortSignal} signal - Optional AbortSignal for cancellation
   */
  async getMe(signal = null) {
    const { data } = await apiClient.get('/api/me', { signal });
    return data;
  },
};

export default authService;

